module.exports = __webpack_public_path__ + "static/media/colorado-utah-map-off.69dd1fa8.png";